<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: { type: String, required: true },
  items: { type: Array, default: () => [] },
  addAllLabel: { type: String, required: true },
  addThisLabel: { type: String, required: true },
});

const emit = defineEmits(['add', 'addAll', 'close']);
</script>

<template>
  <div
    class="flex flex-col w-full overflow-hidden border border-dashed rounded-xl border-n-strong"
  >
    <div class="flex items-center justify-between w-full gap-3 px-4 pt-4 pb-1">
      <div class="flex items-center gap-3">
        <h5 class="text-sm font-medium text-n-slate-11">{{ title }}</h5>
        <span class="w-px h-3 bg-n-weak" />
        <Button
          :label="addAllLabel"
          variant="ghost"
          size="xs"
          color="slate"
          class="!text-sm !text-n-slate-11"
          @click="emit('addAll')"
        />
      </div>
      <Button
        variant="ghost"
        size="xs"
        color="slate"
        icon="i-lucide-x"
        @click="emit('close')"
      />
    </div>
    <div class="flex flex-col w-full divide-y divide-dashed divide-n-strong">
      <div
        v-for="item in items"
        :key="item"
        class="flex items-center justify-between w-full gap-3 px-4 py-4"
      >
        <span class="text-sm text-n-slate-12">{{ item }}</span>
        <Button
          :label="addThisLabel"
          variant="ghost"
          size="xs"
          color="slate"
          class="!text-sm !text-n-slate-11 shrink-0"
          @click="emit('add', item)"
        />
      </div>
    </div>
  </div>
</template>
